class HeaderAnnouncementReviews extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.count) {
      console.error(
        'The element data-header-announcement-reviews-el="count" is required.',
      )
      return
    }

    if (!this.stars) {
      console.error(
        'The element data-header-announcement-reviews-el="stars" is required.',
      )

      return
    }

    this.consumeYotpoApi()
  }

  async consumeYotpoApi () {
    try {
      const response = await fetch(this.url)

      if (response.status !== 200) {
        console.error('Error:', response.status)
      }

      const {
        bottomline: { totalReview = 0, averageScore = 0 } = {},
      } = await response.json()

      if (averageScore && totalReview) {
        this.renderStars(averageScore)
        this.renderCount(averageScore, totalReview)
        this.show()
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  renderStars (averageScore) {
    const wholeStars = Math.floor(averageScore)
    const halfStar = averageScore % 1 !== 0
    let complete = false

    this.stars.forEach((star, index) => {
      if (index + 1 > wholeStars) {
        if (halfStar && !complete) {
          star.setAttribute('fill', 'url(#hd-half-fill)')
          complete = true
        } else {
          star.setAttribute('fill-opacity', '25%')
        }
      }
    })
  }

  renderCount (averageScore, count) {
    const score = Math.round(averageScore * 10) / 10
    this.count.innerText = `(${score}) based on ${count} reviews`
  }

  show () {
    this.setAttribute('aria-hidden', 'false')
  }

  get count () {
    return this.querySelector('[data-header-announcement-reviews-el="count"]')
  }

  get stars () {
    return this.querySelectorAll(
      '[data-header-announcement-reviews-el="stars"] path',
    )
  }

  get url () {
    return `https://api-cdn.yotpo.com/v3/storefront/store/${window.theme.yotpo.apiKey}/reviews`
  }
}

if (!customElements.get('header-announcement-reviews')) {
  customElements.define(
    'header-announcement-reviews',
    HeaderAnnouncementReviews,
  )
}
